<template>
  <BaseLayout>
    <SubHeader></SubHeader>
    <div class="container">
      <div class="section" v-if="$store.getters.subscribed_to_trainer_package">
        <h2>Welcome to the MSM {{$store.getters.active_trainer_package_name}}!</h2>
        <ul>
          <li>You will now have access to post {{$store.state.is_trainer_package_subscriber ? 'up to 15' : 'unlimited'}} horse/equipment listings under the "{{ plans.basic.name }}" price plan.</li>
          <li>Click on "List/Edit/Delete Horse Listings" or "List/Edit/Delete Equipment Listings" then "Add New Listing" and follow the prompts.</li>
          <li>When you get to the "Choose your Price Plan" choose the "{{ plans.basic.name }}" plan for ${{ plans.basic.prices.monthly.price }} - you will see the price zero'd out and you will not be charged. If you choose the "{{ plans.regional.name }}" you will be charged an additional ${{ plans.regional.prices.monthly.price }} for that listing. If this happens - just email us and we will fix it for you.</li>
          <li>Same options for equipment - you are welcome to list unlimited tack, boots, clothes, equipment etc. Just click on Equipment and List Equipment and follow the prompts - make sure you choose the Basic plan and price will be zero'd out.</li>
          <li>When a horse/equipment sells - please delete that listing through the Manage Listings dropdown. You will see "Delete" as an option. This will not affect your Trainer/Breeder or Unlimited Package plan.</li>
          <li>Your card will be charged ${{$store.state.is_trainer_package_subscriber ? plans.trainer_package.prices.monthly.price : plans.unlimited_package.prices.monthly.price}} a month until you unsubscribe from the {{$store.state.is_trainer_package_subscriber ? plans.trainer_package.name : plans.unlimited_package.name}}.</li>
          <li>All listings will be shared on FB and IG @manestreetmarket as a part of our customer service.</li>
          <li>Any questions - please email <a href="mailto:support@manestreetmarket.com">support@manestreetmarket.com</a> - we are here to help!</li>
        </ul>
        <div class="row">
          <router-link to="/my-listings" type="button" class="btn btn-primary">List/Edit/Delete Horse Listings</router-link>
          <router-link to="/my-equipment" type="button" class="btn btn-primary">List/Edit/Delete Equipment Listings</router-link>
          <router-link to="/my-payment-methods" type="button" class="btn btn-primary">Update Payment Method</router-link>
        </div>
      </div>
      <div class="section">
        <i class="fa-solid fa-crown" style="color: #FFD43B;"></i>
        <h2 class="mb-3">Available Plans</h2>
        <div class="package-cards-container">
          <div class="card box-shadow package-card">
            <div class="card-header">
              <h4 class="my-0 font-weight-normal">{{ plans.trainer_package.name }}</h4>
            </div>
            <div class="card-body">
              <div>
                <h3 class="card-title pricing-card-title">${{ plans.trainer_package.prices.monthly.price }}</h3>
                <h3 class="card-title pricing-card-title">PER MONTH</h3>
              </div>
              <p>
                The {{plans.trainer_package.name}} is ideal for trainers/sellers who consistently have 5 - 15 sales horses each month. This package gives you up to 15 Basic Listings (pin on map and included in list). Once you subscribe to the {{plans.trainer_package.name}} - you can add your horses as they are available and delete them when they sell or taken off the market. Listings/Ads also appear on the Mane Street Market app and shared on MSM's FB and IG @manestreetmarket as a part of our customer service.
              </p>
            </div>
            <div class="card-footer">
              <router-link v-if="!$store.state.is_trainer_package_subscriber && !($store.state.is_unlimited_package_subscriber && $store.state.trainer_package_listings > 15)" :to="{name: 'subscribe', params: {id: plans.trainer_package.code}, query: {next_page: 'trainer-package', next_id: 'trainer-package'}}" type="button" class="btn btn-primary">{{ $store.state.is_unlimited_package_subscriber ? 'Downgrade' : 'Subcribe' }}</router-link>
              <a-tooltip v-else-if="$store.state.is_unlimited_package_subscriber && $store.state.trainer_package_listings > 15" title="Unavailable as you have more than 15 listings under the Unlimited Package">
                <button class="btn btn-primary" disabled>Downgrade</button>
              </a-tooltip>
              <button v-else class="btn btn-primary" disabled>Subscribed</button>
            </div>
          </div>
          <div class="card box-shadow package-card">
            <div class="card-header">
              <h4 class="my-0 font-weight-normal">{{ plans.unlimited_package.name }}</h4>
            </div>
            <div class="card-body">
              <div>
                <h3 class="card-title pricing-card-title">${{ plans.unlimited_package.prices.monthly.price }}</h3>
                <h3 class="card-title pricing-card-title">PER MONTH</h3>
              </div>
              <p>
                The {{plans.unlimited_package.name}} includes unlimited Basic Listings (pin on map and included in list) for horses and equipment. This option is ideal for trainers/sellers who consistently have 15 or more sales horses each month and you also get unlimited equipment listings (tack, boots, etc). This is ideal for very large breeding or training/sales barns, live auctions, online auctions etc. Once you subscribe to the {{plans.unlimited_package.name}} - you can add your horses/equipment as they are available and delete them when they sell or taken off the market. Listings/Ads also appear on the Mane Street Market app and shared on MSM's FB and IG @manestreetmarket as a part of our customer service.
              </p>
            </div>
            <div class="card-footer">
              <router-link v-if="!$store.state.is_unlimited_package_subscriber" :to="{name: 'subscribe', params: {id: plans.unlimited_package.code}, query: {next_page: 'trainer-package', next_id: 'unlimited-package'}}" type="button" class="btn btn-primary">{{ $store.state.is_trainer_package_subscriber ? 'Upgrade' : 'Subcribe' }}</router-link>
              <button v-else class="btn btn-primary" disabled>Subscribed</button>
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <h2>FAQ</h2>
        <ACollapse accordion class="faq-collapsibles">
          <APanel header="I currently have multiple basic horse/equipment listings - what happens to them if I subscribe to the Trainer/Breeder Package or the Unlimited Package?" key="1">
            <p>Your current listings will merge into the Trainer/Breeder Package program for the next billing cycle.</p>
          </APanel>
          <APanel header="What are the benefits of choosing the Trainer/Breeder Package or the Unlimited Package?" key="2">
            <p>If you consistently have multiple horses and or equipment for sale - these package are perfect for you.</p>
            <p class="mt-3">The Trainer/Breeder package (${{ plans.trainer_package.prices.monthly.price }} per month) allows you to list up to 15 horses at the Basic option - incredible value if you are consistently listing 5-15 horses per month.</p>
            <p class="mt-3">The Unlimited package (${{ plans.unlimited_package.prices.monthly.price }} per month) is the best value of you list over 11 horses or more - we also offer unlimited equipment listings at this level so feel free to list your tack, boots, clothes and equipment you have for sale.</p>
          </APanel>
          <APanel header="What if I decide to cancel my Trainer/Breeder Package or Unlimited subscription?" key="3">
            <p>You will have the option to delete all of your listings at the time you delete your Trainer/Breeder Package or Unlimited subscriptions or you can choose to keep your selected listings and pay for each horse/equipment individually.</p>
          </APanel>
          <APanel header="I currently have a Basic or Premium listing - how can I upgrade that to a Trainer/Breeder or Unlimited Package?" key="4">
            <p>Please email <a href="mailto:support@manestreetmarket.com">support@manestreetmarket.com</a></p>
          </APanel>
        </ACollapse>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/layouts/Base.vue';
import SubHeader from '@/components/SubHeader.vue';
import ACollapse from 'ant-design-vue/lib/collapse';
import 'ant-design-vue/lib/collapse/style/index.css';
import AButton from 'ant-design-vue/lib/button';
import 'ant-design-vue/lib/button/style/index.css';
import plans from '@/constants/plans';
import AModal from 'ant-design-vue/lib/modal';
import 'ant-design-vue/lib/modal/style/index.css';
import axios from 'axios';
import Swal from "sweetalert2";
import { db } from "@/firebase";
import store from '@/store';
import ATooltip from 'ant-design-vue/lib/tooltip';
import 'ant-design-vue/lib/tooltip/style/index.css';

export default {
  components: {
    BaseLayout,
    SubHeader,
    ACollapse,
    APanel: ACollapse.Panel,
    AButton,
    AModal,
    ATooltip,
  },
  data() {
    return {
      plans,
    }
  },
  mounted() {
    document.title = 'Trainer/Breeder/Unlimited Package - Mane Street Market';
    window.scrollTo(0, 0);

    const user = this.$store.state.user;
    if (user) {
      Promise.all([
        db.collection('Horse').where('publisher', '==', user.uid).get(),
        db.collection('Services').where('publisher', '==', user.uid).get(),
        db.collection('Equipments').where('publisher', '==', user.uid).get()
      ]).then(snapshots => {
        const docs = snapshots.map(snapshot => snapshot.docs.map(doc => doc.data()).filter(d => (d.trainer_package_subscription_id != null || d.unlimited_package_subscription_id != null) && d.is_published)).flat();
        store.dispatch('setTrainerPackageListings', docs.length);
        console.log(docs.length);
      });
    }
  },
  methods: {
    
  },
}
</script>

<style lang="scss" scoped>
  p {
    margin: 0;
  }

  h2 {
    font-weight: 700;
    font-size: 1.6rem;
    color: #051548;
    margin: 0;
  }

  h4 {
    font-size: 1.2rem;
  }

  h3 {
    font-size: 1.4rem;
    font-weight: bold;
  }

  .section {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 800px;
    max-width: 100%;
    margin: auto;
    gap: 16px;

    ul {
      text-align: left;
    }
  }

  .container {
    display: flex;
    flex-direction: column;
    gap: 48px;
  }

  .package-cards-container {
    display: flex;
    gap: 16px;
  }

  .package-card {
    max-width: 400px;
  }

  .faq-collapsibles {
    width: 100%;
    max-width: 800px;
  }

  .cta-section {
    background-color: #F6F6F6;
    border-radius: 8px;
    padding: 32px;
  }

  .row {
    gap: 8px;
  }

  @media (max-width: 480px) {
    .package-cards-container {
      flex-direction: column;
    }
  }
</style>
